import ActivityParticipantSummary from "apps/console/modules/program/workflow/associateProgram/components/activityParticipantSummary";
import { MyExpRoute } from "apps/myExperience/routes/types";
import Icon from "assets/icons";
import sortBy from "lodash/sortBy";
import { Outlet, useNavigate } from "react-router-dom";
import Button from "shared/components/button";
import NoDataFound from "shared/components/noDataFound";
import ToolTip from "shared/components/tooltip";
import TopNoteWithApi from "shared/components/topNote/topNoteWithApi";
import ContextEntityType from "shared/enums/ContextEntityType";
import Variant from "shared/enums/Variant";
import SelectDropdown from "shared/form/core/selectDropdown";
import { useCopies } from "shared/hooks/useCopies";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import ManageActivityCard from "../../invitesSent/list/components/manageActivityCard";
import { useActivityAgendaListingForMarkAttendanceInMyExperienceService } from "./service";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";

export default function ActivityAgendaListingForMarkAttendanceInMyExperience() {
  const service = useActivityAgendaListingForMarkAttendanceInMyExperienceService();
  const navigate = useNavigate();
  const copies = useCopies();
  const { logEvent } = useMyExpAnalytics();

  return (
    <div className="activityAgendaListingForMarkAttendanceInMyExp filtersAndListing">
      {service.utilityDataModule && (
        <TopNoteWithApi
          registrationId={service.registrationId ?? ""}
          contextEntityType={ContextEntityType.PROGRAM}
          contextEntityId={service.programId ?? ""}
          module={service.utilityDataModule}
          logEvent={logEvent}
        />
      )}
      <div className="filtersAndListing-body">
        <div className="filtersAndListing-listing">
          <div className="filtersAndListing-listing_header">
            <SelectDropdown
              isMulti
              isClearable={false}
              value={service.filters}
              options={service.dateOptions}
              onChange={val => {
                if (val.length) {
                  service.setFilters(val as any);
                } else {
                  service.setFilters([]);
                }
              }}
            />
          </div>
          <div className="filtersAndListing-listing_inner">
            {!Boolean(service.agendas?.length) && <NoDataFound height="50vh" />}
            {sortBy(service.agendas || [], "time.timeFrom", "name")?.map(agenda => {
              return (
                <ManageActivityCard
                  name={agenda.name}
                  activityDate={DateTimeHelper.formatDate({
                    startDate: agenda.time.timeFrom,
                    endDate: agenda.time.timeTo,
                    timeZone: agenda.time.timeZoneDisplayStr,
                    option: {
                      showTime: true,
                      showWeekDay: true,
                      showYear: false
                    }
                  })}
                  activityLocation={agenda.location}
                  activitySponsored={agenda.label}
                  inviteAction={
                    agenda.canNotifyOrganizationParticipants && (
                      <ToolTip
                        className="invite_action"
                        content={copies.get("associate.program.notify.colleagues.to.join.tooltip")}>
                        <Button
                          className="content_wrapper--event_notify"
                          variant={Variant.LINK}
                          icon={<Icon.CalendarInvite />}
                          onClick={() =>
                            navigate(
                              `${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.invite.path}/${agenda.id}`
                            )
                          }
                        />
                      </ToolTip>
                    )
                  }
                  action={
                    <div className="manageActivityCardActions">
                      {service.canShowAttendanceBlock && (
                        <div className="manageActivityCardActions_topRow">
                          <div className="manageActivityCardActions_topRow--left checkedInCount">
                            <b>{agenda.participantCountMap?.ATTENDED ?? 0}</b> {copies.get("checked.in")}
                          </div>
                          {service.canShowMarkAttendanceButton && (
                            <div className="manageActivityCardActions_topRow--right">
                              <Button
                                icon={<Icon.UserList size={18} />}
                                label={copies.get("associated.program.action.mark.attendance")}
                                variant={Variant.LINK}
                                onClick={() => navigate(agenda.id)}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div className="manageActivityCardActions_bottomRow">
                        <ActivityParticipantSummary activitySummary={agenda.summary} horizontalStyle />
                        <Button
                          icon={<Icon.Settings size={16} />}
                          label={copies.get("manage.participants.label.in.list")}
                          variant={Variant.LINK}
                          onClick={() =>
                            navigate(
                              `${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.DETAILS.manage.path}/${agenda.id}`
                            )
                          }
                        />
                      </div>
                    </div>
                  }
                  activityElapsed={service.canShowEllapsedTag && agenda.elapsed}
                />
              );
            })}
            <Outlet context={service.selectedAgenda} />
          </div>
        </div>
      </div>
    </div>
  );
}
